import axiosInstance from "../../api/axios";

const useShared = () => {
  const saveCountHandler = async (id: number) => {
    try {
      await axiosInstance.post(`/movies/${id}/shares`, {movie: id});
    } catch (e) {
      console.log(e, 'e');
    }
  }
  return {
    saveCountHandler,
  }
};

export default useShared;
